import { render, staticRenderFns } from "./Lyrics.vue?vue&type=template&id=ef9966b8&scoped=true&"
import script from "./Lyrics.vue?vue&type=script&lang=js&"
export * from "./Lyrics.vue?vue&type=script&lang=js&"
import style0 from "./Lyrics.vue?vue&type=style&index=0&id=ef9966b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef9966b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSlideXReverseTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VSlideXReverseTransition})
